module.exports = __webpack_public_path__ + "img/barber_shop.ffdf3247.jpg";